import { render } from "./LoginLogo.vue?vue&type=template&id=79452558&ts=true"
import script from "./LoginLogo.vue?vue&type=script&lang=ts"
export * from "./LoginLogo.vue?vue&type=script&lang=ts"

import "./LoginLogo.vue?vue&type=style&index=0&id=79452558&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__